/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import {
    CompareOverview, CompareProducts, CustomerOrderInfo, CustomerOrders,
    DynamicContentPage, ErrorMessage, FavoriteProductsPage, FileDownload,
    FilterMetaDescription, FilterProducts, FlashMessage, Footer, GDPRWarning,
    Home, LandingPageMetaDescription, MessageNotification, Navbar, NewsLetter,
    NewsListPage, NewsMetaDescription, NewsPage, NotFound, Order, OrderUpload,
    Page, ProclipMetaDescription, ProductInfo, ResetPassword, SignIn,
    SignInMetaDescription, StateHandler, User, VehicleNewsListPage,
    WelcomeSplash, WithdrawCookiesConsent
} from "./components"
import RouteChangeTracker from "./components/RouteChangeTracker/RouteChangeTracker"
import { useLanguage } from "./lib/hooks/languageHooks"
import { strings as Localization } from "./lib/Localization"
import { clearCustomerOrderErrors } from "./redux/customerOrderReducer"
import useErrors from "./redux/hook/errorHooks"
import { useIsUserAuthorized } from "./redux/hook/userHooks"
import { saveReducers } from "./redux/localStorage"
import { clearPriceErrors } from "./redux/priceSlice"
import store from "./redux/store"
import useStyles from "./styles"
import theme from "./theme"
import {
    Redirect, Route, Switch, useRouteMatch
} from "react-router-dom"
import { useDispatch } from "react-redux"
import { Helmet } from "react-helmet"
import { ThemeProvider } from "@material-ui/core"
import React from "react"

// https://dev.to/link2twenty/react-redux-and-localstorage-2lih
// https://medium.com/edonec/redux-can-be-made-easier-with-redux-toolkit-b1d2d17b90ba

const App = () => {
    const classes = useStyles()
    const language = useLanguage()
    const isAuthorized = useIsUserAuthorized()
    const errors = useErrors()
    const dispatch = useDispatch()

    Localization.setLanguage(language)
    store.subscribe(() => saveReducers(store.getState()))

    const handleCloseError = () => {
        dispatch(clearPriceErrors())
        dispatch(clearCustomerOrderErrors())
    }

    const { path, url } = useRouteMatch()

    return (
        <ThemeProvider theme={theme}>
            <div className={classes.root}>
                <LandingPageMetaDescription />
                <StateHandler />
                <RouteChangeTracker />
                <CompareOverview />
                <GDPRWarning />
                <WelcomeSplash />
                <Navbar />
                <FlashMessage />
                <Switch>
                    <Route
                        exact
                        path={path}
                        render={() => (
                            <Page title={Localization.home}>
                                <Home />
                            </Page>
                        )}
                    />
                    <Route
                        exact
                        path={`${path}/filter`}
                        render={() => (
                            <Page title={Localization.searchResults}>
                                <FilterProducts />
                            </Page>
                        )}
                    />
                    <Route
                        path={`${path}/collections/:collections?/:name?`}
                        render={() => (
                            <Page title={Localization.searchResults}>
                                <FilterProducts />
                            </Page>
                        )}
                    />
                    <Route
                        path={`${path}/filter/collection/:collections?/:name?`}
                        render={() => (
                            <Page title={Localization.searchResults}>
                                <FilterProducts />
                            </Page>
                        )}
                    />
                    <Route
                        path={`${path}/collection/:collections?/:name?`}
                        render={() => (
                            <Page title={Localization.searchResults}>
                                <FilterProducts />
                            </Page>
                        )}
                    />
                    <Route
                        path={`${path}/filter/brand/:brand?/:model?`}
                        render={() => (
                            <Page title={Localization.searchResults}>
                                <FilterProducts />
                            </Page>
                        )}
                    />
                    {/* <Route
                        exact
                        path={`${path}/brand/:brand`}
                        render={() => (
                            <Page title={Localization.searchResults}>
                                <FilterProducts />
                            </Page>
                        )}
                    /> */}
                    <Route
                        path={`${path}/brand/:brand/:model?`}
                        render={() => (
                            <Page title={Localization.searchResults}>
                                <FilterProducts />
                            </Page>
                        )}
                    />
                    <Route
                        exact
                        path={`${path}/product/:id`}
                        render={() => (
                            <Page title={Localization.product}>
                                <ProductInfo />
                            </Page>
                        )}
                    />
                    <Route
                        exact
                        path={`${path}/cart`}
                        render={() => (isAuthorized
                            ? (<Page title={Localization.cart}><Order /></Page>)
                            : (<Redirect to={`${url}/signin`} />))}
                    />
                    <Route
                        exact
                        path={`${path}/signin`}
                        render={
                            () => (
                                !isAuthorized
                                    ? (
                                        <Page title={Localization.logIn}>
                                            {/* <SignInMetaDescription /> */}
                                            <SignIn />
                                        </Page>
                                    )
                                    : <Redirect to={`${url}/user`} />
                            )
                        }
                    />
                    <Route
                        exact
                        path={`${path}/user`}
                        render={() => (isAuthorized
                            ? (<Page title={Localization.account}><User /></Page>)
                            : (<Redirect to={`${url}/signin`} />))}
                    />
                    <Route
                        exact
                        path={`${path}/reset-password/:guid`}
                        render={() => (
                            <Page title={Localization.changePassword}>
                                <ResetPassword />
                            </Page>
                        )}
                    />
                    <Route
                        exact
                        path={`${path}/orders`}
                        render={() => (isAuthorized
                            ? (<Page title={Localization.yourOrders}><CustomerOrders /></Page>)
                            : (<Redirect to={url} />))}
                    />
                    <Route
                        exact
                        path={`${path}/order-upload`}
                        render={() => (isAuthorized
                            ? (<Page title={Localization.upload}><OrderUpload /></Page>)
                            : (<Redirect to={url} />))}
                    />
                    <Route
                        exact
                        path={`${path}/favorites`}
                        render={() => (isAuthorized
                            ? (
                                <Page title={Localization.yourFavorites}>
                                    <FavoriteProductsPage />
                                </Page>
                            )
                            : (<Redirect to={url} />))}
                    />
                    <Route exact path={`${path}/order/:order`} render={() => <Page title={Localization.order}><CustomerOrderInfo /></Page>} />
                    <Route exact path={`${path}/news/*`} render={() => <Page title={Localization.news}><NewsPage /></Page>} />
                    <Route
                        exact
                        path={`${path}/news`}
                        render={() => (
                            <Page title={Localization.news}>
                                <NewsMetaDescription />
                                <NewsListPage />
                            </Page>
                        )}
                    />
                    <Route exact path={`${path}/downloads`} render={() => <Page title={Localization.fileDownload}><FileDownload /></Page>} />
                    <Route
                        exact
                        path={`${path}/proclip`}
                        render={() => (
                            <Page title={Localization.news}>
                                {/* <ProclipMetaDescription /> */}
                                <VehicleNewsListPage />
                            </Page>
                        )}
                    />
                    <Route exact path={`${path}/newsletter`} render={() => <Page title={Localization.newsLetter}><NewsLetter /></Page>} />
                    <Route exact path={`${path}/static/:type`} render={() => <Page title={Localization.information}><DynamicContentPage /></Page>} />
                    <Route exact path={`${path}/brodit40`} render={() => <Page title={Localization.information}><DynamicContentPage type="brodit40" /></Page>} />
                    <Route exact path={`${path}/compare`} render={() => <Page title={Localization.compare}><CompareProducts /></Page>} />
                    <Route exact path={`${path}/withdraw-consent`} render={() => (<Page title={Localization.withdrawingCookiesConsent}><WithdrawCookiesConsent /></Page>)} />
                    <Route render={() => <Page title={Localization.notFound}><NotFound /></Page>} />
                </Switch>
                <Footer />
                <MessageNotification />
                <ErrorMessage open={errors} handleClose={handleCloseError} />
                {" "}
                {/* bort och ersätt med notification?? */}
            </div>
        </ThemeProvider>
    )
}

export default App
